import { forwardRef } from 'react';
import clsx from 'clsx';

const IconButton = forwardRef(function IconButton({ children, className = '', title, ...props }, ref) {
  return (
    <button
      ref={ref}
      type="button"
      title={title}
      className={clsx(
        'relative z-10 rounded-xl p-2 text-[rgb(var(--fg))]/80 transition-colors duration-200',
        'hover:text-[rgb(var(--fg))] hover:bg-[rgba(var(--subpanel),1)]',
        'focus:outline-none focus:ring-2 focus:ring-[rgb(var(--ring))]',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
});

export default IconButton;
